import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ItemDetails } from 'src/app/models/item-details';
import { BookingsComponent } from './bookings/bookings.component';
import { HiresComponent } from './hires/hires.component';
import { KeyDetailsComponent } from './key-details/key-details.component';
import { TransportJobsComponent } from './transport-jobs/transport-jobs.component';
import { WorkshopJobsComponent } from './workshop-jobs/workshop-jobs.component';
@Component({
  selector: 'app-item-summary-section',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    TransportJobsComponent,
    HiresComponent,
    BookingsComponent,
    WorkshopJobsComponent,
    KeyDetailsComponent
  ],
  template: `
    <!-- TODO: Add a loading spinner -->
    <div class="flex flex-col gap-4 items-stretch justify-start py-4">
      @if (type() === 'deliveries') {
        <app-transport-jobs [itemDetails]="details()" />
      } @else if (type() === 'hires') {
        <app-hires
          [itemDetails]="details()"
          (goToHires)="selectTab.emit('hires')"
        />
      } @else if (type() === 'bookings') {
        <app-bookings [itemDetails]="details()" />
      } @else if (type() === 'workshopJobs') {
        <app-workshop-jobs
          [itemDetails]="details()"
          (goToWorkshopJob)="selectTab.emit('workshopJobs')"
        />
      } @else if (type() === 'keyDetails') {
        <app-key-details [itemDetails]="details()" />
      } @else {
        <div class="w-full bg-slate-50 p-4 rounded-lg my-4">
          <p>Type {{ type() }} is not supported</p>
        </div>
      }
    </div>
  `
})
export class ItemSummarySectionComponent {
  details = input.required<ItemDetails>();
  type = input.required<string>();
  selectTab = output<string>();
}
